/* jQuery tubular plugin
|* by Sean McCambridge
|* http://www.seanmccambridge.com/tubular
|* version: 1.0
|* updated: October 1, 2012
|* since 2010
|* licensed under the MIT License */

;(function ($, window) {

    // test for feature support and return if failure  
    // defaults
    var defaults = {
        ratio: 16/9, // usually either 4/3 or 16/9 -- tweak as needed
        videoId: 'ZCAnLxRvNNc', // toy robot in space is a good default, no?
        mute: true,
        repeat: true,
        width: $(window).width(),
        wrapperZIndex: 99,
        playButtonClass: 'tubular-play',
        pauseButtonClass: 'tubular-pause',
        muteButtonClass: 'tubular-mute',
        volumeUpClass: 'tubular-volume-up',
        volumeDownClass: 'tubular-volume-down',
        increaseVolumeBy: 10,
        start: 0
    };

  // methods
  var tubular = function(node, options) { // should be called on the wrapper div
    /*jshint -W004 */
    var options = $.extend({}, defaults, options);

    // set up css prereq's, inject tubular container and set up wrapper defaults
    $('html,body').css({'width': '100%', 'height': '100%'});

    $(node).css({position: 'relative', 'z-index': options.wrapperZIndex});

    // load yt iframe js api
    var tag = document.createElement('script'); 
    tag.src = "https://www.youtube.com/iframe_api";
    
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // resize handler updates width, height and offset of player after resize/init
    var resize = function() {
      var width = $(window).width(),
        pWidth, // player width, to be defined
        height = $(window).height(),
        pHeight, // player height, tbd
        $tubularPlayer = $('#tubular-player');

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (width / options.ratio < height) { // if new video height < window height (gap underneath)
        pWidth = Math.ceil(height * options.ratio); // get new player width
        $tubularPlayer.width(pWidth).height(height).css({left: (width - pWidth) / 2, top: 0}); // player width is greater, offset left; reset top
      } else { // new video width < window width (gap to right)
        pHeight = Math.ceil(width / options.ratio); // get new player height
        $tubularPlayer.width(width).height(pHeight).css({left: 0, top: (height - pHeight) / 2}); // player height is greater, offset top; reset left
      }          
    };

    // set up iframe player, use global scope so YT api can talk
    var player;
    window.onYouTubeIframeAPIReady = function() {
      
      function onPlayerReady(e) {
        resize();
        if (options.mute) { 
          e.target.mute(); 
        }
        
        e.target.seekTo(options.start);
        e.target.setPlaybackQuality('hd1080');
        e.target.playVideo();     
              
        setTimeout(function(){
          $('#video-container').fadeIn(800);                        
        }, 1000);
       
        var videoDuration = player.getDuration();

        setInterval( function() { 
          $('#video-container').fadeOut(800, function(){ 
            player.seekTo(options.start);                                             
          });                        
                
          $('#video-container').fadeIn(800);                        
        }, (videoDuration - 0.8)*1000);     
      } 
 
      function onPlayerStateChange(e) {
        if (e.data === YT.PlayerState.BUFFERING) {
          e.target.setPlaybackQuality('hd1080');
        }
      } 

      function onPlayerPlaybackQualityChange(e) {
          var playbackQuality = e.target.getPlaybackQuality();
          var suggestedQuality = 'hd1080'; 

          if( playbackQuality !== suggestedQuality ) {
              e.target.setPlaybackQuality( suggestedQuality );
          }
      } 
      
      player = new YT.Player('tubular-player', {
        width: options.width,
        height: Math.ceil(options.width / options.ratio),
        videoId: options.videoId,
        playerVars: {
          controls: 0,
          html5: 1,
          showinfo: 0,
          rel: 0,
          enablejsapi:1, 
          modestbranding: 1,
          wmode: 'transparent'
        },
        events: {
          'onReady': onPlayerReady,
          'onPlaybackQualityChange': onPlayerPlaybackQualityChange,
          'onStateChange': onPlayerStateChange
        } 
      });
        
    };

    // events
    $(window).on('resize.tubular', function() {
      resize();
    });

    $('body').on('click','.' + options.playButtonClass, function(e) { // play button
      e.preventDefault();
      player.playVideo();
    }).on('click', '.' + options.pauseButtonClass, function(e) { // pause button
      e.preventDefault();
      player.pauseVideo();
    }).on('click', '.' + options.muteButtonClass, function(e) { // mute button
      e.preventDefault();
      /*jshint -W030 */
      (player.isMuted()) ? player.unMute() : player.mute();
    }).on('click', '.' + options.volumeDownClass, function(e) { // volume down button
      e.preventDefault();
      var currentVolume = player.getVolume();
      if (currentVolume < options.increaseVolumeBy) { 
        currentVolume = options.increaseVolumeBy;
      }
      player.setVolume(currentVolume - options.increaseVolumeBy);
    }).on('click', '.' + options.volumeUpClass, function(e) { // volume up button
      e.preventDefault();
      if (player.isMuted()) {
        player.unMute();  
      } // if mute is on, unmute
      var currentVolume = player.getVolume();
      if (currentVolume > 100 - options.increaseVolumeBy) { 
        currentVolume = 100 - options.increaseVolumeBy; 
      }
      player.setVolume(currentVolume + options.increaseVolumeBy);
    });
  };

  // create plugin
  $.fn.tubular = function (options) {
    return this.each(function () {
      if (!$.data(this, 'tubular_instantiated')) { // let's only run one
         $.data(this, 'tubular_instantiated', 
        tubular(this, options));
      }
    });
  };

})(jQuery, window);